import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
 auth: {
    clientId: "d59a38ba-3e9c-41c5-81e6-4d649532ea69",  // Your B2C App Registration Client ID
    authority: "https://c2stimesheetsb2cprod.b2clogin.com/40682a84-6b8d-425d-a2e1-ffee05048d17/B2C_1_SignUP_SignIn_Prod", 
    redirectUri: "https://timesheet.c2stechs.com/", // Must match the one in Azure App Registration
    //redirectUri: "https://timesheet.c2stechs.com/",
    knownAuthorities: ["c2stimesheetsb2cprod.b2clogin.com"], // Important for B2C
    postLogoutredirectUri: "https://timesheet.c2stechs.com/",
   // postLogoutredirectUri: "https://timesheet.c2stechs.com/",
  },
  cache: {
    cacheLocation: "localStorage", // Stores cache in sessionStorage (better security)
    storeAuthStateInCookie: false, // Set to true if experiencing issues with authentication in IE
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) {
          switch (level) {
            case LogLevel.Error: console.error(message); break;
            case LogLevel.Info: console.info(message); break;
            case LogLevel.Verbose: console.debug(message); break;
            case LogLevel.Warning: console.warn(message); break;
            default: break;
          }
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Info
    }
  }
};

/**
 * Scopes requested for authentication
 */
export const loginRequest = {
  scopes: ["openid", "profile", "email"],
  prompt: "select_account"
};

/**
 * Microsoft Graph API configuration (optional)
 */
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
